import React from 'react';
import styled from 'styled-components';
import propTypes from '../../common/prop-types';
import { SectionDetails } from '../../../shared/sectionable/styles';
import Fees from './fees';
import PerformanceFees from './performance-fees';
import Pricing from './pricing';
import Message from './message';

const Container = styled(SectionDetails)`
  flex-direction: column;
  & > * {
    margin-bottom: ${props => (props.theme.isMobile ? 48 : 32)}px;
  }
`;

export default function Details({ fund }) {
  const { isPerformanceFeeChargedNo } = fund;

  return (
    <Container>
      <Fees fund={fund} />
      {!isPerformanceFeeChargedNo && <PerformanceFees fund={fund} />}
      <Pricing fund={fund} hasTooltips />
      <Message fund={fund} />
    </Container>
  );
}

/* eslint-disable-next-line react/require-default-props */
Details.propTypes = { fund: propTypes.fund };
